import { faUserDoctor } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import DefaultText from '../../../components/Accessibility/DefaultText';
import DefaultTextBold from '../../../components/Accessibility/DefaultTextBold';
import WhiteContainer from '../../../components/Accessibility/WhiteContainer';
import { Psicoterapeuta } from '../../../interfaces/entities/UnimedAcolhe/Psicoterapeuta';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import './styles.css';

const PsicoterapeutaCard: React.FC<{ psicoterapeuta: Psicoterapeuta }> = ({ psicoterapeuta }) => {

  const acessibility = useAccessibility();

  return (
    <WhiteContainer className='psicoterapeuta-card'>
      <FontAwesomeIcon style={acessibility.contrastColorAccessibility} icon={faUserDoctor} className='fa-icon32x32' />
      <Box display='flex' flexDirection='column' gap={`16px`}>
        <DefaultTextBold text={psicoterapeuta.nomeBeneficiario} />
        <DefaultTextBold text={psicoterapeuta.subTitulo} />
        <DefaultText text={psicoterapeuta.descricao} />
      </Box>
    </WhiteContainer>
  )
}

export default PsicoterapeutaCard;